import { $api } from '@service/RequestService';
import { filesEndpoints } from '@utils/constants/apis';
import { useMutation } from 'react-query';

import { File, fileSchema } from '../schema';

export const useUpload = () =>
  useMutation<File[], any, FormData>(
    async values => {
      const { data } = await $api.post(filesEndpoints.INDEX, values);

      const files = (data.data || []).map(fileSchema.parse);

      return files;
    },
    {
      retry: false
    }
  );
